// Um componente já colocado na tela do PDV: pode ser arrastado, selecionado
// e escondido. É o bloco que aparece dentro do preview.
import React from "react";
import { useDrag, useDrop } from "react-dnd";
import * as AlfredoStyles from "../../../../styles/components/configuration/modals/ItemModal";
import { PDVComponent } from "./tipos";

export const ComponenteNoPreview: React.FC<{
  component: PDVComponent;
  onSelect: (component: PDVComponent) => void;
  onUpdate: (componentId: string, updates: any) => void;
  isSelected: boolean;
}> = ({ component, onSelect, onUpdate, isSelected }) => {
  const [{ isDragging }, drag] = useDrag({
    type: "COMPONENT",
    item: {
      type: "MOVE_COMPONENT",
      component,
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const [{ isOver }, drop] = useDrop({
    accept: "COMPONENT",
    drop: (item: any) => {
      if (item.type === "MOVE_COMPONENT") {
        onUpdate(component.componentId, {
          componentProps: {
            ...component.componentProps,
            componentPosition: item.component.componentProps.componentPosition,
          },
        });
      }
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
    }),
  });

  const connectRef = (node: HTMLDivElement) => {
    drag(node);
    drop(node);
  };

  return (
    <AlfredoStyles.DraggableComponent
      ref={connectRef}
      isDragging={isDragging}
      isOver={isOver}
      isSelected={isSelected}
      style={{
        left: component.componentProps.componentPosition?.x || "0%",
        top: component.componentProps.componentPosition?.y || "0%",
        width: component.componentProps.componentWidth || "100px",
        height: component.componentProps.componentHeight || "40px",
        backgroundColor:
          component.componentProps.componentBackgroundColor || "#1D50FF",
        color: component.componentProps.componentColor || "#FFFFFF",
        display: component.componentStatus === "visible" ? "flex" : "none",
      }}
      onClick={() => onSelect(component)}
    >
      <AlfredoStyles.ComponentHandle>
        <span className="material-icons">drag_handle</span>
      </AlfredoStyles.ComponentHandle>
      <AlfredoStyles.ComponentContent>
        {component.componentName}
      </AlfredoStyles.ComponentContent>
      <AlfredoStyles.ComponentActions>
        <button
          onClick={(e) => {
            e.stopPropagation();
            onUpdate(component.componentId, {
              componentStatus:
                component.componentStatus === "visible" ? "hidden" : "visible",
            });
          }}
        >
          <span className="material-icons">
            {component.componentStatus === "visible"
              ? "visibility"
              : "visibility_off"}
          </span>
        </button>
      </AlfredoStyles.ComponentActions>
    </AlfredoStyles.DraggableComponent>
  );
};
